export const environment = {
  production: false,
  respectBrowserUrl: true,
  servicesUrl: 'https://demo-api.mensapp.it/gestione-mense',
  servicesPraticheUrl: 'https://comuni-demo.southengineering.it/gestione-pratiche',
  recaptcha: {
    siteKey: '6Le5wUIhAAAAAE6gf7MCw3W_9oOLw_YuOH8iNHHI',
  },
  spid: {
    authority: 'https://dev-keycloak-upgrade.southengineering.it/auth/realms/gestione-mense',
    clientId: 'mensa-client',
    redirectUri: 'https://dev-gestionemense.southengineering.it/auth/callback',
    postLogoutRedirectUri: 'https://dev-gestionemense.southengineering.it/login',
    scope: 'openid profile email offline_access',
  },
};

